import React, { useEffect, useState } from "react";
import { Toast } from "../UI/toast/Toast";
import { SUCCESS_RESPONSE } from "../../helpers/codeResponses/codes";
import PageHeader from "../common/PageHeader";
import handleErrorMessage from "../../helpers/errors/handleErrorMessage";
import withRedirect from "../../helpers/hoc/withRedirect";
import { useParams, useLocation, useHistory } from "react-router";
import { PreloadState } from "../UI/preloading/PreloadState";
import SupportLink from "../root/support/components/SupportLink";
import { findOne, update } from "../../helpers/api/finance";
import CreateIndividualCostsEditForm from "./CreateIndividualCostsEditForm";
import useModuleBase from "../../helpers/hooks/useModuleBase";

// Gastos particulares (type_id=3) se pueden editar mientras siguen pendientes
// (is_active=true), igual que los ordinarios — ver HO-TASK-230.
const CreateIndividualCostsEdit = ({ setRedirectUrl, setRedirect }) => {
  const moduleBase = useModuleBase();
  const { id, individualId } = useParams();
  const { state } = useLocation();
  const history = useHistory();

  const [common, setCommon] = useState();
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    let isMounted = true;
    const fetchApiCommon = async () => {
      try {
        const response = await findOne(individualId);
        if (isMounted) {
          setCommon(response.data);
        }
      } catch (error) {
        if (isMounted) {
          handleErrorMessage(error);
        }
      } finally {
        if (isMounted) {
          setIsLoading(false);
        }
      }
    };

    fetchApiCommon();

    return () => {
      isMounted = false;
    };
  }, [individualId]);

  const handleEdit = async (values) => {
    try {
      const payload = { ...values };
      // sub_expenses no aplica a gastos particulares; si se manda como null el
      // backend interpreta que la clave está presente y borra el value_finance
      // sin volver a crear uno (ver FinanceController::update).
      delete payload.sub_expenses;

      const { code } = await update(individualId, {
        ...payload,
        condominium_id: Number(id),
        type_id: state?.type_id,
      });

      if (code === SUCCESS_RESPONSE.OK) {
        history.push({
          pathname: `/dashboard/${moduleBase}/${id}/individual-costs`,
          state: {
            type_id: state?.type_id,
            type_name: state?.type_name,
          },
        });

        Toast.fire({
          type: "success",
          title: "Gasto particular actualizado exitosamente.",
        });
      }
    } catch (error) {
      handleErrorMessage(error);
    }
  };

  return (
    <>
      <PageHeader
        title={state?.type_name || "Gasto Particular"}
        titleTag="h2"
        description="Edita un gasto particular pendiente."
        className="mb-3"
        col={{ lg: 9 }}
      >
        <SupportLink />
      </PageHeader>
      <PreloadState loading={isLoading}>
        <CreateIndividualCostsEditForm handleSubmitData={handleEdit} common={common} />
      </PreloadState>
    </>
  );
};

export default withRedirect(CreateIndividualCostsEdit);
